import React, { useEffect, useMemo, useState } from 'react';
import Select from 'react-select';
import { fetchAllCouriers } from 'services/courier_services';

interface CourierSelectProps {
    value: string[];
    onChange: (value: string[]) => void;
    disabled?: boolean;
    isFullscreen?: boolean;
}

export const CourierSelect: React.FC<CourierSelectProps> = ({
    value,
    onChange,
    disabled = false,
    isFullscreen = false
}) => {
    const [couriers, setCouriers] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const loadCouriers = async () => {
            setIsLoading(true);
            setError(null);

            try {
                const userString = localStorage.getItem("USER_SIMO");
                const token = userString ? JSON.parse(userString).token : null;

                if (token) {
                    const data = await fetchAllCouriers(token);
                    setCouriers(data); // data is already [{label, value}]
                } else {
                    console.error('CourierSelect: No token found in localStorage');
                }
            } catch (err) {
                console.error("Error loading couriers", err);
                setError("Error cargando couriers");
            } finally {
                setIsLoading(false);
            }
        };

        loadCouriers();
    }, []);

    // Ensure value is array
    // eslint-disable-next-line
    const safeValue = Array.isArray(value) ? value : [];

    // Create selected options for react-select
    const selectedOptions = useMemo(() => {
        return couriers.filter(c => safeValue.includes(c.value));
    }, [safeValue, couriers]);

    if (error) {
        return <div className="text-red-500 text-xs">Error cargando couriers</div>;
    }

    return (
        <div className="courier-select-container">
            <Select
                isMulti
                value={selectedOptions}
                onChange={(selected) => {
                    const newValue = (selected as unknown as Array<{ value: string }>)?.map(option => option.value) || [];
                    onChange(newValue);
                }}
                options={couriers}
                isDisabled={disabled || isLoading}
                isLoading={isLoading}
                placeholder="Seleccione..."
                noOptionsMessage={() => "No se encontraron couriers"}
                classNamePrefix="courier-select"
                isClearable={true}
                isSearchable={true}
                styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999999 }),
                    menu: (base) => ({ ...base, zIndex: 9999999, fontSize: '12px' }),
                    option: (base) => ({ ...base, fontSize: '12px', padding: '6px 10px' }),
                    control: (base) => ({ ...base, fontSize: '12px', minHeight: '34px' }),
                    valueContainer: (base) => ({ ...base, padding: '2px 8px' }),
                    dropdownIndicator: (base) => ({ ...base, padding: '6px' }),
                    clearIndicator: (base) => ({ ...base, padding: '6px' }),
                    multiValue: (base) => ({ ...base, backgroundColor: '#eff6ff' }),
                    multiValueLabel: (base) => ({ ...base, fontSize: '11px', color: '#1e3a8a' }),
                }}
                menuPortalTarget={isFullscreen ? (document.getElementById('map-portal-root') || document.body) : document.body}
            />
        </div>
    );
};
